import * as actions from './actions';
import * as actionTypes from './actionTypes';
import * as components from './components';
import * as ui from './ui';
import * as constants from './constants';
import * as types from './types';
import reducer from './reducer';

export default {
  actions,
  actionTypes,
  components,
  constants,
  reducer,
  types,
  ui,
}


// WEBPACK FOOTER //
// ./src/modules/search/index.js